import tcwebStyles from './style.min.css?raw';
import connectDropdownStyles from './connect-dropdown-styles.css?raw';
import gridStyles from './style-w-grid.min.css?raw';
import { createReusableStylesheet } from '../reusable-stylesheet';

const tcwebStylesFull = tcwebStyles + ' ' + connectDropdownStyles;

const tcwebReusableStylesheet = createReusableStylesheet(
  'trimble:tcweb-styles',
  tcwebStylesFull
);
const civilTcWebReusableStylesheet = createReusableStylesheet(
  'trimble:civil-tcweb-styles',
  removeCivilExcludedTcwebRules(tcwebStylesFull)
);
const gridReusableStylesheet = createReusableStylesheet(
  'trimble:tcweb-grid-styles',
  gridStyles
);

const tcwebStylesheet = createLegacyStylesheet(
  tcwebReusableStylesheet,
  tcwebStylesFull
);
const gridStylesheet = createLegacyStylesheet(
  gridReusableStylesheet,
  gridStyles
);

export {
  tcwebReusableStylesheet,
  civilTcWebReusableStylesheet,
  tcwebStylesheet,
  gridReusableStylesheet,
  gridStylesheet,
};

function createLegacyStylesheet(
  reusableStylesheet: { readonly sheet?: CSSStyleSheet },
  cssText: string
): CSSStyleSheet {
  const stylesheet = reusableStylesheet.sheet ?? new CSSStyleSheet();

  if (
    !reusableStylesheet.sheet &&
    typeof stylesheet.replaceSync === 'function'
  ) {
    stylesheet.replaceSync(cssText);
  }

  return stylesheet;
}

/**
 * The tcweb stylesheet that was previously used in civil-3d-viewer had some rules manually removed.
 * This function removes those rules from the tcweb stylesheet so that it can be used in civil-3d-viewer without any issues.
 */
function removeCivilExcludedTcwebRules(cssText: string): string {
  return [
    'input[type=text],input[type=email],input[type=password],input[type=number],textarea{display:block;min-height:2.5rem;width:100%;padding:.5rem .75rem;box-sizing:border-box;border:solid .0625rem #d0d0d7;background-color:#fff;color:#363545;font-size:.875rem !important}',
    'input[type=text]:focus,input[type=text].focus,input[type=email]:focus,input[type=email].focus,input[type=password]:focus,input[type=password].focus,input[type=number]:focus,input[type=number].focus,textarea:focus,textarea.focus{outline:none;background-color:#fff}',
    'input[type=text]:focus~.line,input[type=text].focus~.line,input[type=email]:focus~.line,input[type=email].focus~.line,input[type=password]:focus~.line,input[type=password].focus~.line,input[type=number]:focus~.line,input[type=number].focus~.line,textarea:focus~.line,textarea.focus~.line{width:100%;background-color:#005f9e;height:.125rem}',
    'input[type=text]::placeholder,input[type=email]::placeholder,input[type=password]::placeholder,input[type=number]::placeholder,textarea::placeholder{color:#9d9da6;font-style:italic}',
    'input[type=text]:disabled,input[type=text].disabled,input[type=email]:disabled,input[type=email].disabled,input[type=password]:disabled,input[type=password].disabled,input[type=number]:disabled,input[type=number].disabled,textarea:disabled,textarea.disabled{background-color:#eaeaef;cursor:not-allowed}',
    'input[type=text].error,input[type=email].error,input[type=password].error,input[type=number].error,textarea.error{outline:none;background-color:#fff}',
    'input[type=text].error~.line,input[type=email].error~.line,input[type=password].error~.line,input[type=number].error~.line,textarea.error~.line{width:100%;background-color:#c81922;height:.125rem}',
    'input[type=text].error:focus~.line,input[type=text].error.focus~.line,input[type=email].error:focus~.line,input[type=email].error.focus~.line,input[type=password].error:focus~.line,input[type=password].error.focus~.line,input[type=number].error:focus~.line,input[type=number].error.focus~.line,textarea.error:focus~.line,textarea.error.focus~.line{width:100%;background-color:#c81922;height:.125rem}',
    'input[type=file]{font-size:.875rem}',
    'textarea{width:100%;border:solid .0625rem #d0d0d7;resize:vertical}',
    'textarea:focus{outline:0}',
    'textarea:disabled,textarea.disabled{background-color:#eaeaef;cursor:not-allowed}',
    'input[type=text]:read-only,input[type=text].read-only,input[type=email]:read-only,input[type=email].read-only,input[type=password]:read-only,input[type=password].read-only,input[type=number]:read-only,input[type=number].read-only,textarea:read-only,textarea.read-only{display:block;min-height:1.5rem;width:100%;padding:0 !important;box-sizing:border-box;border:none;background-color:rgba(0,0,0,0);cursor:unset}',
    'input[type=text][readonly]:focus~.line,input[type=text][readonly].focus~.line,input[type=email][readonly]:focus~.line,input[type=email][readonly].focus~.line,input[type=password][readonly]:focus~.line,input[type=password][readonly].focus~.line,input[type=number][readonly]:focus~.line,input[type=number][readonly].focus~.line,textarea[readonly]:focus~.line,textarea[readonly].focus~.line{background-color:rgba(0,0,0,0)}',
    'select:disabled,select.disabled,textarea:disabled,textarea.disabled,input[type=text]:disabled,input[type=text].disabled,input[type=email]:disabled,input[type=email].disabled,input[type=password]:disabled,input[type=password].disabled,input[type=number]:disabled,input[type=number].disabled,textarea:disabled,textarea.disabled{opacity:.7}',
  ].reduce((trimmedCssText, rule) => trimmedCssText.replace(rule, ''), cssText);
}
